import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "",
  description: "This video presents the working principle of an electrodynamic shaker.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/04/12/principle/video.mp4`,
            },
          },
          styles: {
            padding: "4.05% 3.1%",
          },
        },
      },
    },
  },
};

export default principle;
